export default __webpack_public_path__ + "static/media/logo_twitter.23dca63d.svg";